<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-tabs v-model="tabLang" class="pb-3 pt-3">
      <v-tab>RU</v-tab>
      <v-tab>UA</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabLang">
      <v-tab-item :eager="true">
        <v-text-field
            v-model="sale.name"
            label="Название"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-textarea
            label="Описание"
            :rules="[rules.required]"
            required
            v-model="sale.description"
            rows="5"
            outlined
        ></v-textarea>
        <v-textarea
            label="Условния акции"
            :rules="[rules.required]"
            required
            v-model="sale.condition"
            rows="5"
            outlined
        ></v-textarea>
        <v-text-field
            v-model="sale.button_text"
            label="Имя кнопки"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
      </v-tab-item>
      <v-tab-item :eager="true">
        <v-text-field
            v-model="sale.name_ua"
            label="Название"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-textarea
            label="Описание"
            :rules="[rules.required]"
            required
            v-model="sale.description_ua"
            rows="5"
            outlined
        ></v-textarea>
        <v-textarea
            label="Условния акции"
            :rules="[rules.required]"
            required
            v-model="sale.condition_ua"
            rows="5"
            outlined
        ></v-textarea>
        <v-text-field
            v-model="sale.button_text_ua"
            label="Имя кнопки"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
      </v-tab-item>
    </v-tabs-items>
    <v-text-field
        v-model="sale.button_url"
        label="Ссылка"
        :rules="[rules.required]"
        required
        outlined
    ></v-text-field>
    <v-select
        label="Где показывать"
        :items="localTypes"
        v-model="sale.type"
        :item-text="item => item.name"
        :item-value="item => item.id"
        outlined>
    </v-select>
    <v-row>
      <v-col class="pt-0 pb-0" cols="6">
        <v-dialog
            ref="dateFromDialog"
            v-model="dateFromModal"
            :return-value.sync="sale.date_from"
            width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="sale.date_from"
                label="Дата начала"
                readonly
                :rules="[rules.required]"
                required
                v-bind="attrs"
                v-on="on"
                outlined
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="sale.date_from"
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="dateFromModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.dateFromDialog.save(sale.date_from  )"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-dialog
            ref="timeFromDialog"
            v-model="timeFromModal"
            :return-value.sync="sale.time_from"
            width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="sale.time_from"
                label="Время от"
                readonly
                v-bind="attrs"
                :rules="[rules.required]"
                required
                v-on="on"
                outlined
            ></v-text-field>
          </template>
          <v-time-picker
              v-model="sale.time_from"
              full-width
              format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="timeFromModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.timeFromDialog.save(sale.time_from  )"
            >
              OK
            </v-btn>
          </v-time-picker>
        </v-dialog>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-dialog
            ref="dateToDialog"
            v-model="dateToModal"
            :return-value.sync="sale.date_to"
            width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="sale.date_to"
                label="Дата окончания"
                readonly
                :rules="[rules.required]"
                required
                v-bind="attrs"
                v-on="on"
                outlined
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="sale.date_to"
              scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="dateToModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.dateToDialog.save(sale.date_to  )"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-dialog
            ref="timeToDialog"
            v-model="timeToModal"
            :return-value.sync="sale.time_to"
            width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="sale.time_to"
                label="Время до"
                readonly
                :rules="[rules.required]"
                required
                v-bind="attrs"
                v-on="on"
                outlined
            ></v-text-field>
          </template>
          <v-time-picker
              v-model="sale.time_to"
              full-width
              format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="timeToModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.timeToDialog.save(sale.time_to  )"
            >
              OK
            </v-btn>
          </v-time-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <v-text-field
        v-model="sale.discount"
        outlined
        label="Скидка"
        suffix="%"
    ></v-text-field>
    <v-row>
       
      <v-col cols="6" class="pt-0 pb-0">

        <v-checkbox
            v-model="sale.enabled"
            label="Включить акцию"
        ></v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
    // @ is an alias to /src


    import UserService from "../../../api/UserService";

    export default {
        name: 'Bonus',
        props: {
            value: Object,
            loading: Boolean,
            rules: Object,
            tabLang: Number
        },
        data() {
            return {
              localTypes: [
                {
                  id: 'all',
                  name: 'Везде',
                },
                {
                  id: 'local',
                  name: 'Одесса',
                },
                {
                  id: 'ukraine',
                  name: 'Новая Почта',
                },
              ],
              sale: this.value,
              dateFromModal: false,
              dateToModal: false,
              timeFromModal: false,
              timeToModal: false,
            }
        },
        mounted() {
        },
        watch: {
          sale(val) {
            this.$emit('input', val);
          }
        },
        methods: {

        }
    }
</script>

<style lang="scss">

</style>
